"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ts_deferred_1 = require("ts-deferred");
const _1 = require(".");
const _2 = require(".");
/**
 * Represents an asynchronous task which may (optionally) monitor for
 * cancellation.
 */
class Task {
    /**
     * Creates a new task. The task passed to the constructor will be executed
     * asynchronously automatically.
     *
     * @param task
     * @param cancellationTokenSource
     */
    constructor(task, cancellationTokenSource) {
        this._cancellationTokenSource = cancellationTokenSource || new _1.CancellationTokenSource();
        this._promise = new Promise((resolve, reject) => {
            task(this._cancellationTokenSource.token).then(resolve, reject);
        });
    }
    /**
     * then function for promise chaining.
     * @param onfulfilled
     * @param onrejected
     * @returns
     */
    then(onfulfilled, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onrejected) {
        return this._promise.then(onfulfilled, onrejected);
    }
    /**
     * Returns a promise which resolves when the task completes.
     */
    get waitHandle() {
        return this._promise;
    }
    /**
     * Requests cancellation of the task.
     */
    async cancel() {
        this._cancellationTokenSource.cancel();
        try {
            await this;
        }
        catch (e) { /* empty block */ }
    }
    /**
     * Creates a task which completes after timeoutMs and monitors the
     * (optional) cancellation token.
     *
     * @param timeoutMs
     * @param cancellationToken
     * @returns
     */
    static delay(timeoutMs, cancellationToken) {
        return new Task(async (ct) => {
            const future = new ts_deferred_1.Deferred();
            const timeout = setTimeout(() => future.resolve(true), timeoutMs);
            const toAwait = [future.promise];
            toAwait.push(ct.waitHandle);
            ct.waitHandle.finally(() => {
                clearTimeout(timeout);
            });
            try {
                const result = await Promise.race(toAwait);
                if (result !== true) {
                    throw new _2.OperationCancelledError();
                }
            }
            finally {
                clearTimeout(timeout);
            }
        }, cancellationToken
            ? _1.CancellationTokenSource.createLinkedTokenSource(cancellationToken)
            : new _1.CancellationTokenSource());
    }
}
exports.default = Task;
//# sourceMappingURL=task.js.map